import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";

import { getAllLeadDestinationsAsync } from "../../../redux/slices/leadDestinations/leadDestinations.asyncActions";
import LeadDestinations from "./LeadDestinations.layout";

const mapStateToProps = (state) => ({
    language: state.languagesState.languages,
    getLeadDestinationsStatus:
        state.leadAllDestinationsState.getAllLeadDestinations.status,
    destinations:
        state.leadAllDestinationsState.getAllLeadDestinations.leadDestinations,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchGetAllDestinations: () => dispatch(getAllLeadDestinationsAsync()),
});

const decorate = compose(connect(mapStateToProps, mapDispatchToProps));

export default decorate(LeadDestinations);
